export const ShareIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.809 11.7479H6.25137C4.64566 11.7479 3.33984 13.0537 3.33984 14.6594V29.2171C3.33984 30.8228 4.64566 32.1286 6.25137 32.1286H20.809C22.4147 32.1286 23.7205 30.8228 23.7205 29.2171V14.6594C23.7205 13.0537 22.4147 11.7479 20.809 11.7479Z"
        fill="#1A1A1A"
      />
      <path
        d="M29.5434 3.01331H14.9857C14.2136 3.01331 13.473 3.32005 12.927 3.86607C12.381 4.41209 12.0742 5.15264 12.0742 5.92483V8.83635H23.7203C24.4925 8.83635 25.233 9.1431 25.7791 9.68912C26.3251 10.2351 26.6318 10.9757 26.6318 11.7479V23.394H29.5434C30.3155 23.394 31.0561 23.0872 31.6021 22.5412C32.1481 21.9952 32.4549 21.2546 32.4549 20.4824V5.92483C32.4549 5.15264 32.1481 4.41209 31.6021 3.86607C31.0561 3.32005 30.3155 3.01331 29.5434 3.01331Z"
        fill="#1A1A1A"
      />
    </svg>
  )
}

export const VkIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.8735 26.8601H28.5529C27.2966 26.8601 26.9181 25.8425 24.666 23.589C22.6978 21.6922 21.8666 21.4563 21.3687 21.4563C20.6802 21.4563 20.4924 21.6456 20.4924 22.5933V25.5805C20.4924 26.3885 20.2303 26.8616 18.1195 26.8616C16.0716 26.724 14.0858 26.1019 12.3255 25.0465C10.5652 23.9911 9.08083 22.5325 7.99465 20.7911C5.4156 17.5811 3.62111 13.8137 2.75391 9.78841C2.75391 9.29054 2.94316 8.83926 3.89231 8.83926H7.21145C8.06452 8.83926 8.37169 9.21921 8.70651 10.097C10.318 14.8399 13.068 18.9655 14.1845 18.9655C14.6125 18.9655 14.7989 18.7763 14.7989 17.7092V12.8237C14.6577 10.5949 13.4741 10.4071 13.4741 9.60062C13.4891 9.38785 13.5864 9.18929 13.7454 9.04713C13.9045 8.90497 14.1126 8.83039 14.3258 8.83926H19.5432C20.2565 8.83926 20.4924 9.19446 20.4924 10.0475V16.6421C20.4924 17.354 20.7981 17.5898 21.0135 17.5898C21.4415 17.5898 21.7705 17.354 22.5552 16.5708C24.2371 14.5196 25.6112 12.2343 26.6342 9.78696C26.7389 9.49312 26.9369 9.24159 27.1979 9.07075C27.4589 8.8999 27.7686 8.81912 28.0798 8.84071H31.4004C32.3961 8.84071 32.6072 9.33858 32.3961 10.049C31.1884 12.7544 29.694 15.3225 27.9386 17.7092C27.5805 18.2551 27.4378 18.539 27.9386 19.1795C28.2676 19.6774 29.4322 20.6498 30.2139 21.5743C31.3523 22.7098 32.2971 24.0228 33.0119 25.4611C33.2972 26.387 32.8212 26.8601 31.8735 26.8601Z"
        fill="#1A1A1A"
      />
    </svg>
  )
}

export const TelegramIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1133_13175)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.5056 6.55088C29.8654 6.39947 30.2591 6.34725 30.6459 6.39966C31.0327 6.45206 31.3983 6.60718 31.7048 6.84886C32.0113 7.09054 32.2474 7.40995 32.3886 7.77384C32.5297 8.13774 32.5708 8.53282 32.5074 8.91795L29.2057 28.9449C28.8855 30.8767 26.7659 31.9845 24.9942 31.0222C23.5123 30.2172 21.3112 28.9769 19.3313 27.6827C18.3414 27.0349 15.309 24.9604 15.6817 23.4843C16.002 22.2222 21.0972 17.4793 24.0087 14.6595C25.1514 13.5516 24.6303 12.9126 23.2808 13.9316C19.9282 16.4617 14.5491 20.3093 12.7702 21.3924C11.2009 22.3474 10.3828 22.5104 9.40448 22.3474C7.61972 22.0504 5.96452 21.5904 4.61357 21.0299C2.78804 20.2729 2.87685 17.7632 4.61211 17.0324L29.5056 6.55088Z"
          fill="#1A1A1A"
        />
      </g>
      <defs>
        <clipPath id="clip0_1133_13175">
          <rect
            width="34.9383"
            height="34.9383"
            fill="white"
            transform="translate(0.714844 0.101807)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
